<template>
    <div :class="`row flex-${position} ${wrapperStyling}`" id="container">
        <button :class="`col xs-${mobile} md-${tablet} lg-${desktop} button ${styling}`" :form="form" :style="{height: height, 'text-align': textAlign}" :disabled="disabled" @click="onClickEventHandler">
            <slot name="content"></slot>
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            position: {
                type: String,
                required: true,
            },
            mobile: {
                type: String,
                required: true,
            },
            tablet: {
                type: String,
                required: true,
            },
            desktop: {
                type: String,
                required: true,
            },
            styling: {
                type: String,
                required: true,
            },
            wrapperStyling: {
                type: String,
                required: false,
            },
            disabled: {
                type: String,
                required: true,
            },
            height: {
                type: String,
                required: false,
                default: "50px"
            },
            textAlign: {
                type: String,
                required: false,
                default: "center",
            },
            form:{
                type:String,
                required: false
            }
        },

        data() {
            return {
            }
        },

        methods: {
            onClickEventHandler() {
                this.$emit("onClickEvent");
            }
        }
    }
</script>

<style lang="scss" scoped>

    .flex-center {
        justify-content: center;
    }

    .flex-left {
        justify-content: flex-start;
    }

    .flex-right {
        justify-content: flex-end;
    }

    #container {
        margin: 20px 0px;
    }

    .button {
        font-family:  "Nitti Grotesk", sans-serif;
        font-size: 20px;
        font-weight: bold;
        line-height: 20px;
    }

    .primary {
        color: white;
        background: #1A74DB;
        border-radius: 4px;
        border: none;
        padding: 0px 40px;
        path {
            fill: white;
        }
    }

    .primary:hover {
        cursor: pointer;
        background-color: #0d6ede;
        border: #0d6ede;
    }

    .primary:disabled {
        opacity: 0.4;
    }

    .rounded {
        border-radius: 50px;
        background: #0184fb;
    }

    .rounded:hover {
        background: #0184fb;
        border: #0184fb;
    }

    .secondary {
        color: #0184fb;
        background: white;
        border: 1px solid #0184fb;
        border-radius: 4px;
        padding: 0px 40px;
        path {
            fill: #0184fb;
        }

        &.rounded {
            border-radius: 50px;
        }
    }

    .secondary:hover {
        cursor: pointer;
        color: white;
        background-color: #0184fb;
        path {
            fill: white;
        }
    }

    .secondary:disabled {
        opacity: 0.4;
    }

    .tertiary {
        color: #1A74DB;
        background:none;
        border: none;
        padding: 0px;
        outline: none;
        path {
            fill: #1A74DB;
        }
    }

    .tertiary:hover {
        cursor: pointer;
        color: #0d6ede;
        path {
            fill: #0d6ede;
        }
    }

    .tertiary:disabled {
        opacity: 0.4;
    }
</style>
